import { GetProjects } from '@/connection/projects/get-projects';
import { serializeError } from '@/store/utils/serialize-error';
import { SelectedBrandliveEvent } from '@/types/projects.types';
import toastTrigger from '@ui/toast/toast-trigger';
import { ProjectsReducerCreator } from '../types';
import { RootState } from '@/store/main';

const loadProjectsReducer = (create: ProjectsReducerCreator) => {
  return create.asyncThunk(
    async (
      {
        channel,
      }: {
        channel: number;
      },
      { rejectWithValue, getState }
    ) => {
      try {
        const rootState = getState() as RootState;
        const projectsState = rootState.projects;
        const results: Awaited<ReturnType<typeof GetProjects>> = await GetProjects({
          channel,
          limit: projectsState.getProjectsOptions.pageSize,
          offset: projectsState.getProjectsOptions.offset,
          sort: projectsState.getProjectsOptions.sort,
          search: projectsState.getProjectsOptions.searchCriteria,
          selectedEventGroupUuid: projectsState.selectedProjectGroup,
          time: projectsState.getProjectsOptions.time,
          templateEvents: false,
          excludeTestEvents: false,
        });

        const projects = results.events || [];
        const totals = results.totals || 0;

        return { projects, totals };
      } catch (e) {
        return rejectWithValue(serializeError(e));
      }
    },
    {
      fulfilled: (state, action) => {
        state.projects = action.payload.projects as unknown as SelectedBrandliveEvent[];
        state.projectsTotals = action.payload.totals;
        state.projectsError = false;
      },
      pending: (state) => {
        state.projectsLoading = true;
      },
      rejected: (state, action) => {
        console.error(action.payload || action.error);
        state.projectsError = true;
        toastTrigger('There was an error loading projects. Please refresh the page.', {
          type: 'error',
          autoClose: 10000,
        });
      },
      settled: (state) => {
        state.projectsLoading = false;
        state.gettingProjectByOption = null;
        state.projectsInitialLoaded = true;
      },
    }
  );
};

export default loadProjectsReducer;
